"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createItemRate = void 0;
var react_1 = __importDefault(require("react"));
var FixedCostRateInputComponent_1 = __importDefault(require("../ItemComponents/FixedCostRateInputComponent"));
var FixedCostRateDisplayComponent_1 = __importDefault(require("../ItemComponents/FixedCostRateDisplayComponent"));
var VariableRateDisplayComponent_1 = __importDefault(require("../ItemComponents/VariableRateDisplayComponent"));
var createItemRate = function (di, itemAdapter, itemStore, clientViewComponents, quoteCurrencyFormatter, quoteAdapter, useEditorControls) {
    if (itemStore.isTextItem) {
        return createNothing();
    }
    else if (!useEditorControls && !itemAdapter.showRate()) {
        return createNothing();
    }
    else if (useEditorControls) {
        if (itemStore.isVariableItem) {
            return createVariableRateInputComponent(di, quoteCurrencyFormatter, clientViewComponents, itemStore);
        }
        else if (itemStore.isFixedCostItem) {
            return createFixedCostRateInputComponent(itemStore, quoteCurrencyFormatter);
        }
    }
    else {
        if (itemStore.isVariableItem) {
            return createVariableRateDisplayComponent(di, itemStore);
        }
        else if (itemStore.isFixedCostItem) {
            return createFixedCostRateDisplayComponent(itemStore, quoteCurrencyFormatter, quoteAdapter);
        }
    }
};
exports.createItemRate = createItemRate;
var createNothing = function () {
    return null;
};
var createVariableRateInputComponent = function (di, quoteCurrencyFormatter, clientViewComponents, itemStore) {
    var VariableRateInput = clientViewComponents.VariableRateInput;
    return (react_1.default.createElement(VariableRateInput, { itemStore: itemStore, variableService: di.get("variableService"), variableEditor: di.get("variableEditor"), currencyCode: quoteCurrencyFormatter.getCurrencyCode() }));
};
var createFixedCostRateInputComponent = function (itemStore, quoteCurrencyFormatter) {
    return react_1.default.createElement(FixedCostRateInputComponent_1.default, { itemStore: itemStore, currencySymbol: quoteCurrencyFormatter.getSymbol() });
};
var createVariableRateDisplayComponent = function (di, itemStore) {
    var variableService = di.get("variableService");
    var variableId = itemStore.variableRateId;
    var variable = variableService.getVariable(variableId);
    return react_1.default.createElement(VariableRateDisplayComponent_1.default, { variableName: variable ? variable.name : "" });
};
var createFixedCostRateDisplayComponent = function (itemStore, quoteCurrencyFormatter, quoteAdapter) {
    return (react_1.default.createElement(FixedCostRateDisplayComponent_1.default, { rateAmount: itemStore.rateAmount, idealDecimalPlaces: quoteCurrencyFormatter.idealDecimalPlaces(), currencyCode: quoteCurrencyFormatter.getCurrencyCode(), forceShowDecimalPlaces: quoteAdapter.showDecimalPlaces() }));
};
